<div class="container flex-col gap-16">
    <div class="flex-col gap-16 form"
         [formGroup]="form">
        <div class="flex-col gap-8">
            <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
            <input class="ui-input ui-input-40"
                   formControlName="name">
        </div>


        <div class="flex-col gap-8">
            <label>{{ 'FLOW_CHART.NODES.WEBHOOK.WEBHOOK'|translate }} <span class="required">*</span></label>

            <div class="flex-row gap-8 start-center">
                <webhook-select (webhookIdSelectOutput)="onWebhookIdChange($event)"
                                [initValue]="this.form.controls['webhookId'].value"
                                [disabled]="disableForm()"
                                [disabledWebhooksMap]="disabledWebhooksMapSig()">
                </webhook-select>
                
                @if(!disableForm() && selectNodeSig()) {
                <span class="ui-icon-edit c-p"
                      [matTooltip]="'COMMON.EDIT' | translate"
                      matTooltipClass="sidebar-tooltip"
                      (click)="edit()"></span>
                }
            </div>
        </div>

        <div class="flex-col gap-8">
            <label>{{ 'FLOW_CHART.TIMEOUT_S'|translate }} <span class="required">*</span></label>
            <input formControlName="timeoutS"
                   class="ui-input ui-input-40"
                   type="number"
                   min="0" />
        </div>
    </div>

    @if(selectNodeSig()) {
    <div class="copy-container">
        <div class="flex-col gap-8">
            <label>{{ 'FLOW_CHART.NODES.WEBHOOK.URL_LABEL'|translate }}</label>
            <div class="flex-row start-center gap-8">
                <input disabled
                       class="ui-input ui-input-40 w-100 org-id-input"
                       [value]="selectNodeSig().preview.options['webhookUrl']">
                <ui-copy-clipboard class="c-p"
                                   #clipboard
                                   [copyContent]="selectNodeSig().preview.options['webhookUrl']"
                                   (click)="clipboard.copyContent">
                </ui-copy-clipboard>
            </div>
        </div>
    </div>
    }
</div>